import orm from 'models'

import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { createSelector as ormSelector } from 'redux-orm'
import { createSelector } from 'reselect'
import { createFilteredEntitiesSelector } from "selectors/entities";
import getEntities from 'selectors/entities'
import { getKeyWindowSelector } from 'selectors/key_windows'

const moment = extendMoment(Moment)

const getConsultations = ormSelector(orm, getEntities, (session) => {
  return session.consultation.all().toModelArray()
                .filter(consultation => !consultation.deleted)
                .map(consultation => {
                  const { ref } = consultation

                  let dossier = session.dossier.withId(consultation.dossierId)
                  let dossierHash = {};

                  if (dossier) {
                    const patient = session.contact.withId(dossier.patientId)
                    dossierHash = {
                      ...dossier.ref,
                      patient: patient ? patient.ref : null
                    }
                  }

                  return {
                    ...ref,
                    dossier: dossierHash,
                    practioner: session.employment.withId(consultation.practionerId),
                    consultationType: session.consultationType.withId(consultation.consultationTypeId),
                    location: session.location.withId(consultation.locationId),
                    event: session.event.withId(consultation.eventId)
                  }
                })
})

export const getSortedConsultationsForListByKeyWindow = (keyWindow) => {
  return createSelector([getKeyWindowSelector('consultation', keyWindow, getConsultations)], (consultations) => _.sortBy(consultations, [(consultation) => consultation.event && consultation.event.startTime] ))
}
export const getFilteredSortedConsultations = (keywindow) => createFilteredEntitiesSelector(getSortedConsultationsForListByKeyWindow(keywindow),'consultation')

const getDateRange = (state, props) => moment.range(props.startDate, props.endDate)

export const getConsultationsInDateRange = createSelector([getKeyWindowSelector('consultation', 'stats', getConsultations), getDateRange],
                                                          (consultations, dateRange) => {
                                                            return consultations.filter( consultation => consultation.event && consultation.event.startTime && dateRange.contains(moment(consultation.event.startTime)))
                                                          }
)




